import {LocationDescriptorObject} from "history";
import {SagaIterator, delay} from "redux-saga";
import {put, select, call, takeEvery, takeLatest} from "redux-saga/effects";
import {replace} from "react-router-redux";
import {session, reconnect} from "@neolab/ice-client";

import {RootState} from "src/reducers";


function locationSelector(state: RootState) {
  return state.routing.locationBeforeTransitions;
}


function* redirectToLogin(): SagaIterator {
  // delay to next tick to allow react-router initialize when this is called
  // synchronously with startup. In this case `state.routing` will be empty.
  yield call(delay, 0);

  const currentLocation: LocationDescriptorObject =
    yield select(locationSelector);

  const {pathname, state} = currentLocation;

  if (pathname === '/login')
    return;

  let followup: LocationDescriptorObject = {pathname: '/'};

  if (pathname === '/logging-in') {
    followup = state && (state as any).followup;
  }

  yield put(replace({
    pathname: '/login',
    state: {followup}, // defined for go back after failed login
  }));
}


function* redirectToFollowup(): SagaIterator {
  const currentLocation: LocationDescriptorObject =
    yield select(locationSelector);

  const {pathname, state} = currentLocation;

  if (pathname === '/login' || pathname === '/logging-in') {
    const followup: LocationDescriptorObject =
      state && (state as any).followup;

    yield put(replace(followup || {pathname: '/'}));
  }
}


export default function* loginRoutingSaga(): SagaIterator {
  yield takeEvery([
    session.done.type, reconnect.failed.type,
  ], redirectToLogin);
  yield takeLatest(session.started.type, redirectToFollowup);
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/sagas/loginRouting.ts